import { render, staticRenderFns } from "./AddCatalog.vue?vue&type=template&id=790974c0"
import script from "./AddCatalog.vue?vue&type=script&lang=ts"
export * from "./AddCatalog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports